module.exports = __webpack_public_path__ + "static/media/YouTubeLogo.1db42e6e.svg";